<template>
  <div>
    <baseModal
      id="newStylist"
      size="sm"
      title="Assing Customer to Stylist"
      :show="showCreate"
      @closed="onClosed"
      @shown="onShown"
    >
      <SearchBar v-model="q" />

      <div
        v-for="(customer, index) in customers"
        :key="index"
        @click="assign(customer)"
      >
        <div class="d-flex align-items-center">
          <Avatar
            :size="44"
            class="mr-2"
            :img="customer.profile_pic"
            :username="`${customer.first_name} ${customer.last_name}`"
          />
          {{ customer.first_name }} {{ customer.last_name }}
        </div>
        <hr>
      </div>
    </baseModal>
  </div>
</template>

<script>
export default {
  name: 'AssignStylist',
  props: {
    stylist: Object,
  },
  data() {
    return {
      showCreate: false,
      q: '',
    };
  },
  computed: {
    customers() {
      return this.$store.state.customers.unassigned;
    },
  },
  watch: {
    q(newVal, oldVal) {
      console.log(newVal, oldVal);
      this.fetch();
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$store.dispatch('customers/fetchUnassigned', this.q);
    },
    onClosed() {
      this.showCreate = false;
      this.$emit('closed');
    },
    open() {
      this.showCreate = true;
    },
    onShown() {
      this.fetch();
    },
    assign(person) {
      console.log(person);
      console.log(this.stylist);
      this.$store.dispatch('customers/assignCustomerToStylist', [person, this.stylist]);
      // Optimistic
      // this.
      // patch
      // remove from unasigned
      // add to asigned
    },

  },
};
</script>
